import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useCustomShortcode from '@hooks/useCustomShortcode'

import { confirmDelete } from '@functions/entity'

const CustomShortcodeListItem = (props) => {
  const { customShortcode } = props

  const {
    callbacks: {
      createOrEditCustomShortcode,
      deleteCustomShortcode: deleteFn,
    },
    customShortcode: {
      key,
      title,
      value,
    },
  } = useCustomShortcode(customShortcode)

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure? This could affect artwork population.',
      entityName: 'Custom Shortcode',
    },
  }

  return (
    <DashboardModuleListItem
      secondaryText={key}
      title={title}
    >
      <DashboardModuleListItem.TertiaryText>
        {value}
      </DashboardModuleListItem.TertiaryText>

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditCustomShortcode()}
          type="edit"
        />
        <DashboardModuleListItem.Icon onClick={() => confirmDelete(confirmDeletePayload)} type="delete" />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

CustomShortcodeListItem.propTypes = {
  customShortcode: PropTypes.object.isRequired,
}

export default CustomShortcodeListItem
